var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2505 9.5H19.7505M4.25055 9.5H5.75055M12.7505 1V2.5M6.74005 3.49L7.80005 4.551M18.7605 3.49L17.6995 4.551M13.406 6.2135C8.99655 10.0625 4.24905 14.9035 2.56255 16.6485C2.16755 17.057 2.04155 17.6525 2.26905 18.1725C2.39305 18.455 2.53955 18.7635 2.69105 19.026C2.84255 19.2885 3.03655 19.5695 3.21955 19.818C3.55555 20.2755 4.13455 20.4635 4.68555 20.326C7.04005 19.7375 13.6065 18.047 19.1445 16.153",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8059 8.59655C10.8059 8.59655 11.8514 9.64255 13.6239 12.7125C15.3964 15.7825 15.7794 17.211 15.7794 17.211M11.3479 18.6785L11.6449 19.7875C11.7229 20.0788 11.7428 20.3825 11.7034 20.6814C11.664 20.9803 11.5662 21.2685 11.4154 21.5295C11.2647 21.7906 11.064 22.0194 10.8248 22.2029C10.5856 22.3864 10.3126 22.521 10.0214 22.599C9.73018 22.6771 9.42647 22.6969 9.12757 22.6576C8.82868 22.6182 8.54048 22.5203 8.2794 22.3696C8.01833 22.2188 7.78951 22.0181 7.606 21.7789C7.42249 21.5397 7.2879 21.2668 7.20989 20.9755L6.96289 20.0515M13.0229 5.55005C13.0229 5.55005 14.2214 6.86055 16.6059 10.991C18.9904 15.1215 19.5264 16.8145 19.5264 16.8145",
    stroke: "#B2B3B7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedIcon);
export default __webpack_public_path__ + "static/media/FeedIcon.e3a00db138ef6b775cc48605ea378328.svg";
export { ForwardRef as ReactComponent };